import { render, staticRenderFns } from "./Doppus.vue?vue&type=template&id=7789c3a4&"
import script from "./Doppus.vue?vue&type=script&lang=js&"
export * from "./Doppus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports